import type { AuthorityType, Result } from '@/types/';
import MatchListPageIcon from '@/assets/icon/header/MatchResultPageIcon.svg?url';
import TeamResultPageIcon from '@/assets/icon/header/TeamResultPageIcon.svg?url';
import VideoListPageIcon from '@/assets/icon/header/VideoListPageIcon.png?url';
import ComparisonPageIcon from '@/assets/icon/header/VideoComparisonPageIcon.png?url';
import DocumentPageIcon from '@/assets/icon/header/DocumentPageIcon.svg?url';
import SinglePlayVideoPageIcon from '@/assets/icon/header/SinglePlayVideoPageIcon.png?url';

export const AUTHORITY_TYPE: Record<AuthorityType, Record<string, string>> = {
  admin: {
    value: 'admin',
    name: '管理者'
  },
  coach: {
    value: 'coach',
    name: 'コーチ'
  },
  general: {
    value: 'general',
    name: '一般'
  }
} as const;

export interface linkItem {
  title: string;
  to: string;
  icon: string;
  isActive: boolean;
}

export enum DayOfWeek {
  SUN, // 0
  MON, // 1
  TUE, // 2
  WED, // 3
  THU, // 4
  FRI, // 5
  SAT // 6
}

export const LINKS: linkItem[] = [
  {
    title: '試合一覧',
    to: '/matchlist',
    icon: MatchListPageIcon,
    isActive: true
  },
  {
    title: 'チーム・個人成績',
    to: '/',
    icon: TeamResultPageIcon,
    isActive: false
  },
  {
    title: '映像一覧',
    to: '/videolist',
    icon: VideoListPageIcon,
    isActive: true
  },
  {
    title: '一球映像',
    to: '/singleplayvideo',
    icon: SinglePlayVideoPageIcon,
    isActive: true
  },
  {
    title: '比較',
    to: '/comparison',
    icon: ComparisonPageIcon,
    isActive: true
  },
  {
    title: 'ドキュメント',
    to: '/documentlist',
    icon: DocumentPageIcon,
    isActive: true
  }
] as const;

export const WEATHER = {
  1: {
    _id: 1,
    name: '晴れ',
    show_index: 0,
    name_s: '晴れ',
    name_e: 'fine',
    name_es: 'fine'
  },
  2: {
    _id: 2,
    name: '晴れ時々くもり',
    show_index: 0,
    name_s: '晴れ時々くもり',
    name_e: 'fine, occasionally cloudy',
    name_es: 'fine, occasionally cloudy'
  },
  3: {
    _id: 3,
    name: '晴れのちくもり',
    show_index: 0,
    name_s: '晴れのちくもり',
    name_e: 'fine, cloudy later',
    name_es: 'fine, cloudy later'
  },
  4: {
    _id: 4,
    name: 'くもり',
    show_index: 0,
    name_s: 'くもり',
    name_e: 'cloudy',
    name_es: 'cloudy'
  },
  5: {
    _id: 5,
    name: 'くもり時々晴れ',
    show_index: 0,
    name_s: 'くもり時々晴れ',
    name_e: 'cloudy, occasionally fine',
    name_es: 'cloudy, occasionally fine'
  },
  6: {
    _id: 6,
    name: 'くもりのち晴れ',
    show_index: 0,
    name_s: 'くもりのち晴れ',
    name_e: 'cloudy, fine later',
    name_es: 'cloudy, fine later'
  },
  7: {
    _id: 7,
    name: 'くもり時々雨',
    show_index: 0,
    name_s: 'くもり時々雨',
    name_e: 'cloudy, occasionally rain',
    name_es: 'cloudy, occasionally rain'
  },
  8: {
    _id: 8,
    name: 'くもりのち雨',
    show_index: 0,
    name_s: 'くもりのち雨',
    name_e: 'cloudy, rain later',
    name_es: 'cloudy, rain later'
  },
  9: {
    _id: 9,
    name: '晴れ時々雨',
    show_index: 0,
    name_s: '晴れ時々雨',
    name_e: 'fine, occasionally rain',
    name_es: 'fine, occasionally rain'
  },
  10: {
    _id: 10,
    name: '晴れのち雨',
    show_index: 0,
    name_s: '晴れのち雨',
    name_e: 'fine, rain later',
    name_es: 'fine, rain later'
  },
  11: {
    _id: 11,
    name: '雨時々晴れ',
    show_index: 0,
    name_s: '雨時々晴れ',
    name_e: 'rain, occasionally fine',
    name_es: 'rain, occasionally fine'
  },
  12: {
    _id: 12,
    name: '雨のち晴れ',
    show_index: 0,
    name_s: '雨のち晴れ',
    name_e: 'rain, fine later',
    name_es: 'rain, fine later'
  },
  13: {
    _id: 13,
    name: '雨時々くもり',
    show_index: 0,
    name_s: '雨時々くもり',
    name_e: 'rain, occasionally cloudy',
    name_es: 'rain, occasionally cloudy'
  },
  14: {
    _id: 14,
    name: '雨のちくもり',
    show_index: 0,
    name_s: '雨のちくもり',
    name_e: 'rain, cloudy later',
    name_es: 'rain, cloudy later'
  },
  15: { _id: 15, name: '雨', show_index: 0, name_s: '雨', name_e: 'rain', name_es: 'rain' },
  16: { _id: 16, name: '嵐', show_index: 0, name_s: '嵐', name_e: 'storm', name_es: 'storm' },
  17: { _id: 17, name: '雪', show_index: 0, name_s: '雪', name_e: 'snow', name_es: 'snow' },
  18: {
    _id: 18,
    name: '変な天気',
    show_index: 0,
    name_s: '変な天気',
    name_e: 'unpredictable weather',
    name_es: 'unpredictable weather'
  }
} as const;

export const BS_COUNT = [
  '0-0',
  '0-1',
  '0-2',
  '1-0',
  '1-1',
  '1-2',
  '2-0',
  '2-1',
  '2-2',
  '3-0',
  '3-1',
  '3-2'
] as const;

export const BATTED_BALL_DIRECTION = [
  {
    value: 'fl',
    label: '左上'
  },
  {
    value: 'bl',
    label: '左下'
  },
  {
    value: 'fc',
    label: '中央上'
  },
  {
    value: 'bc',
    label: '中央下'
  },
  {
    value: 'fr',
    label: '右上'
  },
  {
    value: 'br',
    label: '右下'
  }
] as const;

export const PC_TOTAL_HEADER_HEIGHT = 148 as const;
export const SP_TOTAL_HEADER_HEIGHT = 130 as const;

export const CACHER_MIT_POSITION = [
  {
    value: 5,
    label: '高内角'
  },
  {
    value: 3,
    label: '高め'
  },
  {
    value: 6,
    label: '高外角'
  },
  {
    value: 1,
    label: '内角'
  },
  {
    value: 4,
    label: '真ん中'
  },
  {
    value: 2,
    label: '外角'
  }
] as const;

export const PITCH_OPERATION = [
  {
    label: '逆球',
    value: 'opposite_ball'
  },
  {
    label: 'クイック',
    value: 'slide_step_flag'
  },
  {
    label: 'ワンバウンド',
    value: 'one_bound_flag'
  },
  {
    label: 'パスボール',
    value: 'pass_ball'
  },
  {
    label: 'ワイルドピッチ',
    value: 'wild_pitch'
  }
] as const;

export const PLAN_TYPE = [
  {
    label: 'バント',
    value: 'bant'
  },
  {
    label: '盗塁',
    value: 'steal'
  },
  {
    label: 'エンドラン',
    value: 'and_run'
  }
] as const;

export const RESULT_STATS_TYPE = {
  OTHER: 0,
  BATTED_GOOD: 1,
  BATTED_BAD: 2,
  SACRIFICE: 3,
  MISSED: 4,
  SWING: 5
} as const;

export const SWING_RESULT_TYPE = {
  FOUL: 1,
  WHIFF: 12
};

// Add this to your existing constants.ts
export const UPLOAD_CHUNK_SIZE = 50 * 1024 * 1024; // 50MB

export const RESULT_OPTIONS = new Map<string, Result>(
  [
    {
      _id: 'result-0',
      name: 'なし',
      last_id: '12',
      show_index: 99,
      name_s: 'なし',
      name_e: 'None',
      name_es: 'None',
      stats_id: 0,
      bat_ground_flg: false,
      bat_fly_flg: false,
      bat_drive_flg: false,
      list_id: '0',
      list_x: 0,
      list_y: 0,
      list_color: 'black',
      scope_color: 'green',
      bat_color: 'black',
      bat_circle_flg: false,
      bat_fillstyle: 0,
      pit_flg: false,
      disp_flg: false,
      batting_flg: false,
      bat_yn: false,
      runs: 0,
      batruns_flg: false,
      bat_must_chk: false,
      last_ball: false,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-1',
      name: 'ファウル',
      last_id: '4',
      show_index: 2,
      name_s: 'ファウル',
      name_e: 'Foul',
      name_es: 'Foul',
      stats_id: RESULT_STATS_TYPE.SWING,
      bat_ground_flg: true,
      bat_fly_flg: true,
      bat_drive_flg: true,
      list_id: '1',
      list_x: 1,
      list_y: 4,
      list_color: 'silver',
      scope_color: 'yellow',
      bat_color: 'yellow',
      bat_circle_flg: true,
      bat_fillstyle: 0,

      pit_flg: true,
      disp_flg: true,
      batting_flg: true,
      bat_yn: true,
      runs: 0,
      batruns_flg: false,
      bat_must_chk: true,
      last_ball: false,
      strike: true,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-2',
      name: '単打',
      last_id: '1',
      show_index: 1,
      name_s: '単打',
      name_e: 'Single',
      name_es: 'Single',
      stats_id: RESULT_STATS_TYPE.BATTED_GOOD,
      bat_ground_flg: true,
      bat_fly_flg: true,
      bat_drive_flg: true,
      list_id: '5',
      list_x: 2,
      list_y: 1,
      list_color: 'navy',
      scope_color: 'navy',
      bat_color: 'navy',
      bat_circle_flg: true,
      bat_fillstyle: 0,

      pit_flg: true,
      disp_flg: true,
      batting_flg: true,
      bat_yn: true,
      runs: 1,
      batruns_flg: true,
      bat_must_chk: true,
      last_ball: true,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-3',
      name: '死球',
      last_id: '10',
      show_index: 99,
      name_s: '死球',
      name_e: 'Hit by Pitch',
      name_es: 'HBP',
      stats_id: 0,
      bat_ground_flg: false,
      bat_fly_flg: false,
      bat_drive_flg: false,
      list_id: '5',
      list_x: 5,
      list_y: 1,
      list_color: 'olive',
      scope_color: 'aqua',
      bat_color: 'aqua',
      bat_circle_flg: true,
      bat_fillstyle: 0,
      pit_flg: true,
      disp_flg: true,
      batting_flg: false,
      bat_yn: false,
      runs: 1,
      batruns_flg: true,
      bat_must_chk: false,
      last_ball: true,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-4',
      name: '二塁打',
      last_id: '1',
      show_index: 2,
      name_s: '二塁打',
      name_e: 'Double',
      name_es: '2B',
      stats_id: RESULT_STATS_TYPE.BATTED_GOOD,
      bat_ground_flg: true,
      bat_fly_flg: true,
      bat_drive_flg: true,
      list_id: '5',
      list_x: 2,
      list_y: 2,
      list_color: 'navy',
      scope_color: 'navy',
      bat_color: 'navy',
      bat_circle_flg: true,
      bat_fillstyle: 0,

      pit_flg: true,
      disp_flg: true,
      batting_flg: true,
      bat_yn: true,
      runs: 2,
      batruns_flg: true,
      bat_must_chk: true,
      last_ball: true,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-5',
      name: 'エンタイトル２ベース',
      last_id: '1',
      show_index: 99,
      name_s: 'ｴﾝﾀｲﾄﾙ2B',
      name_e: 'Ground-Rule Double',
      name_es: 'Grd-Rule 2B',
      stats_id: 1,
      bat_ground_flg: true,
      bat_fly_flg: true,
      bat_drive_flg: true,
      list_id: '5',
      list_x: 2,
      list_y: 3,
      list_color: 'navy',
      scope_color: 'navy',
      bat_color: 'navy',
      bat_circle_flg: true,
      bat_fillstyle: 0,
      pit_flg: true,
      disp_flg: true,
      batting_flg: true,
      bat_yn: true,
      runs: 2,
      batruns_flg: true,
      bat_must_chk: true,
      last_ball: true,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-6',
      name: '三塁打',
      last_id: '1',
      show_index: 3,
      name_s: '三塁打',
      name_e: 'Triple',
      name_es: '3B',
      stats_id: RESULT_STATS_TYPE.BATTED_GOOD,
      bat_ground_flg: true,
      bat_fly_flg: true,
      bat_drive_flg: true,
      list_id: '5',
      list_x: 3,
      list_y: 1,
      list_color: 'navy',
      scope_color: 'navy',
      bat_color: 'navy',
      bat_circle_flg: true,
      bat_fillstyle: 0,

      pit_flg: true,
      disp_flg: true,
      batting_flg: true,
      bat_yn: true,
      runs: 3,
      batruns_flg: true,
      bat_must_chk: true,
      last_ball: true,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-7',
      name: '本塁打',
      last_id: '1',
      show_index: 4,
      name_s: '本塁打',
      name_e: 'Home Run',
      name_es: 'HR',
      stats_id: RESULT_STATS_TYPE.BATTED_GOOD,
      bat_ground_flg: true,
      bat_fly_flg: true,
      bat_drive_flg: true,
      list_id: '5',
      list_x: 3,
      list_y: 2,
      list_color: 'navy',
      scope_color: 'navy',
      bat_color: 'navy',
      bat_circle_flg: true,
      bat_fillstyle: 0,

      pit_flg: true,
      disp_flg: true,
      batting_flg: true,
      bat_yn: true,
      runs: 4,
      batruns_flg: true,
      bat_must_chk: true,
      last_ball: true,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-8',
      name: '失策出塁',
      last_id: '5',
      show_index: 99,
      name_s: '失策出塁',
      name_e: 'Base on Error',
      name_es: 'BOE',
      stats_id: RESULT_STATS_TYPE.OTHER,
      bat_ground_flg: true,
      bat_fly_flg: true,
      bat_drive_flg: true,
      list_id: '5',
      list_x: 1,
      list_y: 3,
      list_color: 'black',
      scope_color: 'black',
      bat_color: 'black',
      bat_circle_flg: true,
      bat_fillstyle: 0,

      pit_flg: true,
      disp_flg: true,
      batting_flg: true,
      bat_yn: true,
      runs: 1,
      batruns_flg: true,
      bat_must_chk: true,
      last_ball: true,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-9',
      name: '凡打',
      last_id: '2',
      show_index: 5,
      name_s: '凡打',
      name_e: 'Out',
      name_es: 'Out',
      stats_id: RESULT_STATS_TYPE.BATTED_BAD,
      bat_ground_flg: true,
      bat_fly_flg: true,
      bat_drive_flg: true,
      list_id: '5',
      list_x: 1,
      list_y: 1,
      list_color: 'black',
      scope_color: 'black',
      bat_color: 'black',
      bat_circle_flg: true,
      bat_fillstyle: 0,

      pit_flg: true,
      disp_flg: true,
      batting_flg: true,
      bat_yn: true,
      runs: 0,
      batruns_flg: false,
      bat_must_chk: true,
      last_ball: true,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-10',
      name: '犠打',
      last_id: '6',
      show_index: 6,
      name_s: '犠打',
      name_e: 'Sacrifice Hit',
      name_es: 'SH',
      stats_id: RESULT_STATS_TYPE.BATTED_BAD,
      bat_ground_flg: true,
      bat_fly_flg: true,
      bat_drive_flg: false,
      list_id: '5',
      list_x: 4,
      list_y: 1,
      list_color: 'lime',
      scope_color: 'green',
      bat_color: 'green',
      bat_circle_flg: true,
      bat_fillstyle: 0,
      pit_flg: true,
      disp_flg: true,
      batting_flg: true,
      bat_yn: true,
      runs: 0,
      batruns_flg: false,
      bat_must_chk: true,
      last_ball: true,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: true,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-11',
      name: '犠飛',
      last_id: '7',
      show_index: 99,
      name_s: '犠飛',
      name_e: 'Sacrifice Fly',
      name_es: 'SF',
      stats_id: 6,
      bat_ground_flg: false,
      bat_fly_flg: true,
      bat_drive_flg: true,
      list_id: '5',
      list_x: 4,
      list_y: 2,
      list_color: 'lime',
      scope_color: 'green',
      bat_color: 'green',
      bat_circle_flg: true,
      bat_fillstyle: 0,
      pit_flg: true,
      disp_flg: true,
      batting_flg: true,
      bat_yn: true,
      runs: 0,
      batruns_flg: false,
      bat_must_chk: true,
      last_ball: true,
      strike: false,
      ball: false,
      out: false,
      tag_up: true,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-12',
      name: '空振',
      last_id: '3',
      show_index: 1,
      name_s: '空振',
      name_e: 'Strike Swing',
      name_es: 'Stk Swing',
      stats_id: RESULT_STATS_TYPE.SWING,
      bat_ground_flg: false,
      bat_fly_flg: false,
      bat_drive_flg: false,
      list_id: '1',
      list_x: 1,
      list_y: 1,
      list_color: 'gray',
      scope_color: 'teal',
      bat_color: 'lime',
      bat_circle_flg: false,
      bat_fillstyle: 0,

      pit_flg: true,
      disp_flg: true,
      batting_flg: true,
      bat_yn: false,
      runs: 0,
      batruns_flg: false,
      bat_must_chk: false,
      last_ball: false,
      strike: true,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-13',
      name: '見送',
      last_id: '3',
      show_index: 99,
      name_s: '見送',
      name_e: 'Strike Looking',
      name_es: 'Stk Looking',
      stats_id: 4,
      bat_ground_flg: false,
      bat_fly_flg: false,
      bat_drive_flg: false,
      list_id: '1',
      list_x: 1,
      list_y: 2,
      list_color: 'gray',
      scope_color: 'teal',
      bat_color: 'olive',
      bat_circle_flg: false,
      bat_fillstyle: 0,
      pit_flg: true,
      disp_flg: true,
      batting_flg: false,
      bat_yn: false,
      runs: 0,
      batruns_flg: false,
      bat_must_chk: false,
      last_ball: false,
      strike: true,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-14',
      name: 'ボール',
      last_id: '9',
      show_index: 2,
      name_s: 'ボール',
      name_e: 'Ball',
      name_es: 'Ball',
      stats_id: RESULT_STATS_TYPE.MISSED,
      bat_ground_flg: false,
      bat_fly_flg: false,
      bat_drive_flg: false,
      list_id: '1',
      list_x: 1,
      list_y: 3,
      list_color: 'purple',
      scope_color: 'aqua',
      bat_color: 'aqua',
      bat_circle_flg: false,
      bat_fillstyle: 0,

      pit_flg: true,
      disp_flg: true,
      batting_flg: false,
      bat_yn: false,
      runs: 0,
      batruns_flg: false,
      bat_must_chk: false,
      last_ball: false,
      strike: false,
      ball: true,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-15',
      name: '四球',
      last_id: '9',
      show_index: 99,
      name_s: '四球',
      name_e: 'Base on Ball',
      name_es: 'BB',
      stats_id: 0,
      bat_ground_flg: false,
      bat_fly_flg: false,
      bat_drive_flg: false,
      list_id: '0',
      list_x: 0,
      list_y: 0,
      list_color: 'black',
      scope_color: 'aqua',
      bat_color: 'aqua',
      bat_circle_flg: false,
      bat_fillstyle: 0,
      pit_flg: true,
      disp_flg: false,
      batting_flg: false,
      bat_yn: false,
      runs: 1,
      batruns_flg: true,
      bat_must_chk: false,
      last_ball: true,
      strike: false,
      ball: true,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-16',
      name: '邪飛',
      last_id: '4',
      show_index: 7,
      name_s: '邪飛',
      name_e: 'Foul Out',
      name_es: 'Foul Out',
      stats_id: RESULT_STATS_TYPE.BATTED_BAD,
      bat_ground_flg: false,
      bat_fly_flg: true,
      bat_drive_flg: true,
      list_id: '5',
      list_x: 1,
      list_y: 2,
      list_color: 'black',
      scope_color: 'black',
      bat_color: 'black',
      bat_circle_flg: true,
      bat_fillstyle: 0,

      pit_flg: true,
      disp_flg: true,
      batting_flg: true,
      bat_yn: true,
      runs: 0,
      batruns_flg: false,
      bat_must_chk: true,
      last_ball: true,
      strike: false,
      ball: false,
      out: true,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-17',
      name: '牽制',
      last_id: '12',
      show_index: 99,
      name_s: '牽制',
      name_e: 'Pickoff Throw',
      name_es: 'PK Throw',
      stats_id: 0,
      bat_ground_flg: false,
      bat_fly_flg: false,
      bat_drive_flg: false,
      list_id: '0',
      list_x: 0,
      list_y: 0,
      list_color: 'black',
      scope_color: 'black',
      bat_color: 'black',
      bat_circle_flg: false,
      bat_fillstyle: 0,
      pit_flg: false,
      disp_flg: false,
      batting_flg: false,
      bat_yn: false,
      runs: 0,
      batruns_flg: false,
      bat_must_chk: false,
      last_ball: false,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-18',
      name: '盗塁',
      last_id: '12',
      show_index: 99,
      name_s: '盗塁',
      name_e: 'Steal',
      name_es: 'Steal',
      stats_id: 0,
      bat_ground_flg: false,
      bat_fly_flg: false,
      bat_drive_flg: false,
      list_id: '0',
      list_x: 0,
      list_y: 0,
      list_color: 'black',
      scope_color: 'black',
      bat_color: 'black',
      bat_circle_flg: false,
      bat_fillstyle: 0,
      pit_flg: false,
      disp_flg: false,
      batting_flg: false,
      bat_yn: false,
      runs: 0,
      batruns_flg: false,
      bat_must_chk: false,
      last_ball: false,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-19',
      name: '交代',
      last_id: '12',
      show_index: 99,
      name_s: '交代',
      name_e: 'Change Player',
      name_es: 'Change Player',
      stats_id: 0,
      bat_ground_flg: false,
      bat_fly_flg: false,
      bat_drive_flg: false,
      list_id: '0',
      list_x: 0,
      list_y: 0,
      list_color: 'black',
      scope_color: 'black',
      bat_color: 'black',
      bat_circle_flg: false,
      bat_fillstyle: 0,
      pit_flg: false,
      disp_flg: false,
      batting_flg: false,
      bat_yn: false,
      runs: 0,
      batruns_flg: false,
      bat_must_chk: false,
      last_ball: false,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-20',
      name: 'ボーク',
      last_id: '5',
      show_index: 99,
      name_s: 'ボーク',
      name_e: 'Balk',
      name_es: 'Balk',
      stats_id: 0,
      bat_ground_flg: false,
      bat_fly_flg: false,
      bat_drive_flg: false,
      list_id: '2',
      list_x: 1,
      list_y: 1,
      list_color: 'white',
      scope_color: 'black',
      bat_color: 'black',
      bat_circle_flg: false,
      bat_fillstyle: 0,
      pit_flg: false,
      disp_flg: true,
      batting_flg: false,
      bat_yn: false,
      runs: 1,
      batruns_flg: false,
      bat_must_chk: false,
      last_ball: false,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-21',
      name: '打撃妨害',
      last_id: '11',
      show_index: 8,
      name_s: '打撃妨害',
      name_e: 'Defensive Interference',
      name_es: 'Def. IF',
      stats_id: RESULT_STATS_TYPE.OTHER,
      bat_ground_flg: false,
      bat_fly_flg: false,
      bat_drive_flg: false,
      list_id: '5',
      list_x: 6,
      list_y: 1,
      list_color: 'black',
      scope_color: 'silver',
      bat_color: 'silver',
      bat_circle_flg: true,
      bat_fillstyle: 0,

      pit_flg: true,
      disp_flg: true,
      batting_flg: true,
      bat_yn: true,
      runs: 1,
      batruns_flg: true,
      bat_must_chk: false,
      last_ball: true,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-22',
      name: '守備妨害',
      last_id: '5',
      show_index: 9,
      name_s: '守備妨害',
      name_e: 'Offensive Interference',
      name_es: 'Off. IF',
      stats_id: RESULT_STATS_TYPE.OTHER,
      bat_ground_flg: false,
      bat_fly_flg: false,
      bat_drive_flg: false,
      list_id: '5',
      list_x: 6,
      list_y: 2,
      list_color: 'black',
      scope_color: 'silver',
      bat_color: 'silver',
      bat_circle_flg: true,
      bat_fillstyle: 0,

      pit_flg: true,
      disp_flg: true,
      batting_flg: true,
      bat_yn: true,
      runs: 0,
      batruns_flg: false,
      bat_must_chk: false,
      last_ball: true,
      strike: false,
      ball: false,
      out: true,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-23',
      name: '走塁妨害',
      last_id: '5',
      show_index: 99,
      name_s: '走塁妨害',
      name_e: 'Obstruction',
      name_es: 'OB',
      stats_id: 7,
      bat_ground_flg: false,
      bat_fly_flg: false,
      bat_drive_flg: false,
      list_id: '5',
      list_x: 5,
      list_y: 3,
      list_color: 'black',
      scope_color: 'silver',
      bat_color: 'silver',
      bat_circle_flg: true,
      bat_fillstyle: 0,
      pit_flg: true,
      disp_flg: true,
      batting_flg: true,
      bat_yn: true,
      runs: 1,
      batruns_flg: true,
      bat_must_chk: false,
      last_ball: true,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-24',
      name: '振り逃げ',
      last_id: '3',
      show_index: 99,
      name_s: '振り逃げ',
      name_e: 'Safe at first on third strike',
      name_es: 'Kd3',
      stats_id: 3,
      bat_ground_flg: false,
      bat_fly_flg: false,
      bat_drive_flg: false,
      list_id: '5',
      list_x: 5,
      list_y: 2,
      list_color: 'olive',
      scope_color: 'teal',
      bat_color: 'lime',
      bat_circle_flg: false,
      bat_fillstyle: 0,
      pit_flg: true,
      disp_flg: true,
      batting_flg: true,
      bat_yn: false,
      runs: 1,
      batruns_flg: true,
      bat_must_chk: false,
      last_ball: false,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-25',
      name: 'タイム',
      last_id: '12',
      show_index: 99,
      name_s: 'タイム',
      name_e: 'Time',
      name_es: 'Time',
      stats_id: 0,
      bat_ground_flg: false,
      bat_fly_flg: false,
      bat_drive_flg: false,
      list_id: '9',
      list_x: 1,
      list_y: 1,
      list_color: 'black',
      scope_color: 'black',
      bat_color: 'black',
      bat_circle_flg: false,
      bat_fillstyle: 0,
      pit_flg: false,
      disp_flg: true,
      batting_flg: false,
      bat_yn: false,
      runs: 0,
      batruns_flg: false,
      bat_must_chk: false,
      last_ball: false,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-26',
      name: 'アピールプレー',
      last_id: '12',
      show_index: 99,
      name_s: 'アピール',
      name_e: 'Appeal Play',
      name_es: 'Appeal Play',
      stats_id: 0,
      bat_ground_flg: false,
      bat_fly_flg: false,
      bat_drive_flg: false,
      list_id: '9',
      list_x: 1,
      list_y: 2,
      list_color: 'black',
      scope_color: 'black',
      bat_color: 'black',
      bat_circle_flg: false,
      bat_fillstyle: 0,
      pit_flg: false,
      disp_flg: true,
      batting_flg: false,
      bat_yn: false,
      runs: 0,
      batruns_flg: false,
      bat_must_chk: false,
      last_ball: false,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-27',
      name: '走塁',
      last_id: '12',
      show_index: 99,
      name_s: '走塁',
      name_e: 'Running',
      name_es: 'Running',
      stats_id: 0,
      bat_ground_flg: false,
      bat_fly_flg: false,
      bat_drive_flg: false,
      list_id: '0',
      list_x: 0,
      list_y: 0,
      list_color: 'black',
      scope_color: 'black',
      bat_color: 'black',
      bat_circle_flg: false,
      bat_fillstyle: 0,
      pit_flg: false,
      disp_flg: false,
      batting_flg: false,
      bat_yn: false,
      runs: 0,
      batruns_flg: false,
      bat_must_chk: false,
      last_ball: false,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-28',
      name: '反則投球',
      last_id: '5',
      show_index: 99,
      name_s: '反則投球',
      name_e: 'Illegal Pitch',
      name_es: 'Ill. Pitch',
      stats_id: 0,
      bat_ground_flg: false,
      bat_fly_flg: false,
      bat_drive_flg: false,
      list_id: '2',
      list_x: 1,
      list_y: 2,
      list_color: 'white',
      scope_color: 'aqua',
      bat_color: 'aqua',
      bat_circle_flg: false,
      bat_fillstyle: 0,
      pit_flg: false,
      disp_flg: true,
      batting_flg: false,
      bat_yn: false,
      runs: 0,
      batruns_flg: false,
      bat_must_chk: false,
      last_ball: false,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-29',
      name: '15秒ルール',
      last_id: '5',
      show_index: 99,
      name_s: '15秒ルール',
      name_e: 'Fifteen-Second Rule',
      name_es: '15sec Rule',
      stats_id: 0,
      bat_ground_flg: false,
      bat_fly_flg: false,
      bat_drive_flg: false,
      list_id: '2',
      list_x: 1,
      list_y: 3,
      list_color: 'white',
      scope_color: 'black',
      bat_color: 'black',
      bat_circle_flg: false,
      bat_fillstyle: 0,
      pit_flg: false,
      disp_flg: true,
      batting_flg: false,
      bat_yn: false,
      runs: 0,
      batruns_flg: false,
      bat_must_chk: false,
      last_ball: false,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-30',
      name: '野選',
      last_id: '2',
      show_index: 1,
      name_s: '野選',
      name_e: "Fielder's Choice",
      name_es: 'FC',
      stats_id: RESULT_STATS_TYPE.OTHER,
      bat_ground_flg: true,
      bat_fly_flg: true,
      bat_drive_flg: true,
      list_id: '5',
      list_x: 6,
      list_y: 3,
      list_color: 'black',
      scope_color: 'black',
      bat_color: 'black',
      bat_circle_flg: true,
      bat_fillstyle: 0,

      pit_flg: true,
      disp_flg: true,
      batting_flg: true,
      bat_yn: true,
      runs: 1,
      batruns_flg: true,
      bat_must_chk: true,
      last_ball: true,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-31',
      name: '空振三振',
      last_id: '3',
      show_index: 99,
      name_s: '空三振',
      name_e: 'Strikeout Swinging',
      name_es: 'SO Swinging',
      stats_id: 3,
      bat_ground_flg: false,
      bat_fly_flg: false,
      bat_drive_flg: false,
      list_id: '0',
      list_x: 0,
      list_y: 0,
      list_color: 'black',
      scope_color: 'teal',
      bat_color: 'lime',
      bat_circle_flg: false,
      bat_fillstyle: 0,
      pit_flg: true,
      disp_flg: false,
      batting_flg: true,
      bat_yn: false,
      runs: 0,
      batruns_flg: false,
      bat_must_chk: false,
      last_ball: true,
      strike: true,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-32',
      name: '見送三振',
      last_id: '3',
      show_index: 99,
      name_s: '見三振',
      name_e: 'Strikeout Looking',
      name_es: 'SO Looking',
      stats_id: 4,
      bat_ground_flg: false,
      bat_fly_flg: false,
      bat_drive_flg: false,
      list_id: '0',
      list_x: 0,
      list_y: 0,
      list_color: 'black',
      scope_color: 'teal',
      bat_color: 'olive',
      bat_circle_flg: false,
      bat_fillstyle: 0,
      pit_flg: true,
      disp_flg: false,
      batting_flg: false,
      bat_yn: false,
      runs: 0,
      batruns_flg: false,
      bat_must_chk: false,
      last_ball: true,
      strike: true,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-33',
      name: '先発',
      last_id: '12',
      show_index: 99,
      name_s: '先発',
      name_e: 'Starting Lineup',
      name_es: 'Starting Lineup',
      stats_id: 0,
      bat_ground_flg: false,
      bat_fly_flg: false,
      bat_drive_flg: false,
      list_id: '0',
      list_x: 0,
      list_y: 0,
      list_color: 'black',
      scope_color: 'black',
      bat_color: 'black',
      bat_circle_flg: false,
      bat_fillstyle: 0,
      pit_flg: false,
      disp_flg: false,
      batting_flg: false,
      bat_yn: false,
      runs: 0,
      batruns_flg: false,
      bat_must_chk: false,
      last_ball: false,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-34',
      name: '犠打失策',
      last_id: '6',
      show_index: 4,
      name_s: '犠打失策',
      name_e: 'Sacrifice Hit and Error',
      name_es: 'SH & E',
      stats_id: RESULT_STATS_TYPE.OTHER,
      bat_ground_flg: true,
      bat_fly_flg: true,
      bat_drive_flg: false,
      list_id: '5',
      list_x: 4,
      list_y: 3,
      list_color: 'lime',
      scope_color: 'green',
      bat_color: 'green',
      bat_circle_flg: true,
      bat_fillstyle: 0,

      pit_flg: true,
      disp_flg: true,
      batting_flg: true,
      bat_yn: true,
      runs: 1,
      batruns_flg: true,
      bat_must_chk: true,
      last_ball: true,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: true,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-35',
      name: '犠飛失策',
      last_id: '7',
      show_index: 5,
      name_s: '犠飛失策',
      name_e: 'Sacrifice Fly and Error',
      name_es: 'SF & E',
      stats_id: RESULT_STATS_TYPE.OTHER,
      bat_ground_flg: false,
      bat_fly_flg: true,
      bat_drive_flg: true,
      list_id: '5',
      list_x: 4,
      list_y: 4,
      list_color: 'lime',
      scope_color: 'green',
      bat_color: 'green',
      bat_circle_flg: true,
      bat_fillstyle: 0,

      pit_flg: true,
      disp_flg: true,
      batting_flg: true,
      bat_yn: true,
      runs: 1,
      batruns_flg: true,
      bat_must_chk: true,
      last_ball: true,
      strike: false,
      ball: false,
      out: false,
      tag_up: true,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-36',
      name: '犠打野選',
      last_id: '6',
      show_index: 2,
      name_s: '犠打野選',
      name_e: "Sacrifice Hit and Fielder's Choice",
      name_es: 'SH & FC',
      stats_id: RESULT_STATS_TYPE.OTHER,
      bat_ground_flg: true,
      bat_fly_flg: true,
      bat_drive_flg: false,
      list_id: '5',
      list_x: 5,
      list_y: 4,
      list_color: 'lime',
      scope_color: 'green',
      bat_color: 'green',
      bat_circle_flg: true,
      bat_fillstyle: 0,

      pit_flg: true,
      disp_flg: true,
      batting_flg: true,
      bat_yn: true,
      runs: 1,
      batruns_flg: true,
      bat_must_chk: true,
      last_ball: true,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: true,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-37',
      name: '野選失策',
      last_id: '2',
      show_index: 3,
      name_s: '野選失策',
      name_e: "Fielder's Choice and Error",
      name_es: 'FC & E',
      stats_id: RESULT_STATS_TYPE.OTHER,
      bat_ground_flg: true,
      bat_fly_flg: true,
      bat_drive_flg: true,
      list_id: '5',
      list_x: 6,
      list_y: 4,
      list_color: 'black',
      scope_color: 'black',
      bat_color: 'black',
      bat_circle_flg: true,
      bat_fillstyle: 0,

      pit_flg: true,
      disp_flg: true,
      batting_flg: true,
      bat_yn: true,
      runs: 1,
      batruns_flg: true,
      bat_must_chk: true,
      last_ball: true,
      strike: false,
      ball: false,
      out: false,
      tag_up: false,
      bunt: false,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    },
    {
      _id: 'result-38',
      name: 'スリーバント失敗',
      last_id: '3',
      show_index: 8,
      name_s: 'ｽﾘｰﾊﾞﾝﾄ失敗',
      name_e: 'Three Strike Bunt Failed',
      name_es: '3SBF',
      stats_id: RESULT_STATS_TYPE.BATTED_BAD,
      bat_ground_flg: false,
      bat_fly_flg: false,
      bat_drive_flg: false,
      list_id: '5',
      list_x: 1,
      list_y: 4,
      list_color: 'black',
      scope_color: 'yellow',
      bat_color: 'yellow',
      bat_circle_flg: false,
      bat_fillstyle: 0,

      pit_flg: true,
      disp_flg: true,
      batting_flg: true,
      bat_yn: true,
      runs: 0,
      batruns_flg: false,
      bat_must_chk: true,
      last_ball: true,
      strike: true,
      ball: false,
      out: false,
      tag_up: false,
      bunt: true,
      dev: '',
      bat_circle_color: '',
      bat_drawstyle: '',
      id: 0,
      _rev: '',
      type: 'result'
    }
  ].map((item) => [item._id, item] as const)
);

export const BATTED_BALL_FEATURE_OPTION = [
  { label: 'ゴロ', value: 1 },
  { label: 'フライ', value: 2 },
  { label: 'ライナー', value: 3 }
] as const;

export const MEMO_COMMENT_MAX_RANGE = 500 as const;

export const VIDEO_TITLE_MAX_RANGE = 50 as const;

export const VIDEO_DESCRIPTION_MAX_RANGE = 200 as const;

/** 1ページあたりの動画取得数上限（映像一覧のページネーション） */
export const VIDEO_LIST_PAGE_LIMIT = 50 as const;

export const BATTER_BOX_ID_TYPE: Record<string, string> = {
  ['1']: 'left',
  ['2']: 'right'
};

export const PITCHER_BOX_ID_TYPE = {
  LEFT: '1',
  RIGHT: '2'
} as const;